import {includes} from 'lodash';
import promiseRetry from 'promise-retry';

import {ApiError} from 'types';

const shouldRetry = (error: ApiError, notRetryOnStatus: number[]) => error?.message === 'Network Error' ||
    (error?.response?.status && !includes(notRetryOnStatus, error?.response?.status));

type RetryOptions = {
    retries?: number;
    timeout?: number;
    notRetryOnStatus?: number[]
    throwError?: boolean;
}
const retryRequest = <T>(promise: Promise<T>, {retries = 3, timeout = 2000, throwError = true, ...options}: RetryOptions = {}):
Promise<T> =>
        promiseRetry((retry) => promise.catch((error) => {
            if (shouldRetry(error, options.notRetryOnStatus)) {
                return retry(error);
            }
            if (throwError) {
                throw error;
            }
        }), {
            retries,
            minTimeout: timeout,
            maxTimeout: timeout
        });

export const httpUtils = {
    retryRequest
};